import { merge } from 'ramda'

import { createReducer } from 'utils/redux'

import * as actions from './actions'

const receiveProfileSettings = ({ draft, action }) => {
  if (!action.payload.type) {
    return merge(draft, action.payload)
  }
}

const reducerActions = {
  [actions.fetchUserProfileSuccess]: receiveProfileSettings,
  [actions.patchUserProfileSuccess]: receiveProfileSettings,
}

const profileReducer = createReducer({}, reducerActions)

export default profileReducer
